import React, { useCallback } from 'react';
import { type ColorValue } from 'react-native';

import { HeaderLeft, HeaderRight } from './components';
import { type HeaderLeftProps, type HeaderRightProps } from './Header.props';

/**
 * Returns a function, populated with the specified items,
 * which can be passed as the `headerLeft` option of a native stack navigator.
 */
export const useHeaderLeft = (props: HeaderLeftProps) => {
  return useCallback(
    (headerProps: HeaderButtonProps) => (
      <HeaderLeft
        {...headerProps}
        {...props}
        tintColor={props.tintColor ?? getHeaderTintColor(headerProps.tintColor)}
      />
    ),
    [props],
  );
};

/**
 * Returns a function, populated with the specified items,
 * which can be passed as the `headerRight` option of a native stack navigator.
 */
export const useHeaderRight = (props: HeaderRightProps) => {
  return useCallback(
    (headerProps: HeaderButtonProps) => (
      <HeaderRight
        {...headerProps}
        {...props}
        tintColor={props.tintColor ?? getHeaderTintColor(headerProps.tintColor)}
      />
    ),
    [props],
  );
};

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getHeaderTintColor(tintColor: ColorValue | undefined) {
  return typeof tintColor === 'string' ? tintColor : undefined;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type HeaderButtonProps = {
  tintColor?: ColorValue;
  canGoBack?: boolean;
  label?: string;
};
